module.exports = __webpack_public_path__ + "static/img/i4.bc57f06.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/i4.png
// module id = YmYV
// module chunks = 0